export default {
  common: {
    success: 'Success',
  },
  // 其他翻译内容
}
